import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { ForbrugsnotifikationSektionIndstilling } from "../model/forbrugsnotifikation-indstillinger.model";

@Component({
    selector: "forbrugsnotifikation-sektion",
    templateUrl: "./forbrugsnotifikation-sektion.component.html",
    styleUrls: ["./forbrugsnotifikation-sektion.component.scss"]
})
export class ForbrugsnotifikationSektionComponent {
    @Input() public formGroup: UntypedFormGroup;
    @Input() public indstillinger: ForbrugsnotifikationSektionIndstilling;
    @Input() public min: number;
    @Input() public max: number;
    @Input() public suffix = "";

    constructor() {
        this.onDisplayWith = this.onDisplayWith.bind(this);
    }

    public get brugerdefineret(): boolean {
        return this.formGroup.get("brugerdefineret").value;
    }

    public onDisplayWith(value: number): string {
        return `${value}${this.suffix}`;
    }

    formatLabel(value: number): string {
        if (value >= 1000) {
            return Math.round(value / 1000) + "k";
        }

        return `${value}`;
    }
}
